import React, { memo } from 'react';
import {
  Stack,
  Typography,
  FormControlLabel,
  Switch,
  Button,
  Icon,
  Chip,
  Divider
} from 'investira.react.components';
import { useIndicadoresContext } from '../../../contexts/IndicadoresContext';
import { PAISES } from '../../../enums';
import { getIndicadoresTipoRouteById } from '../_shared/indicadoresTipoRoute';

const IndicadorHeader = memo(props => {
  const { preciseOption = false, compare = false } = props;
  const { state, actions } = useIndicadoresContext();
  const { indicador, indicador_id, indicador_tipo_id, pais_id } = state.indicador.current || {};
  const xIndicadorTipo = getIndicadoresTipoRouteById(indicador_tipo_id);
  const xPais = PAISES[pais_id];

  const handleChange = event => {
    actions.handleShowPreciseChange(event.target.checked);
  };

  return (
    <Stack spacing={1}>
      <Stack
        direction="row"
        spacing={3}
        alignItems="center"
        justifyContent="space-between"
        sx={{ py: 1 }}>
        <Stack direction="row" spacing={3} alignItems="center">
          <Stack
            backgroundColor="primary.main"
            width="50px"
            height="50px"
            justifyContent="center"
            alignItems="center"
            borderRadius="8px">
            <Icon iconName={xIndicadorTipo?.iconName} color="secondary" size={24} />
          </Stack>
          <Stack>
            <Typography variant="h5" color="textPrimary">
              {indicador_id}
            </Typography>
            <Typography variant="caption" color="textPrimary">
              {indicador}
            </Typography>
          </Stack>
        </Stack>

        {preciseOption && (
          <Stack>
            <FormControlLabel
              sx={{ marginRight: 0 }}
              control={<Switch checked={state.showPrecise} onChange={handleChange} />}
              label={
                <Typography variant="body2" color="textPrimary">
                  Valores simples
                </Typography>
              }
            />
          </Stack>
        )}
      </Stack>

      {(xIndicadorTipo?.descricao || xPais?.pais) && (
        <Stack direction="row" alignItems="center" gap={1} flexWrap="wrap">
          {xIndicadorTipo?.descricao && (
            <Chip
              label={xIndicadorTipo.descricao}
              size="small"
              color="primary"
              variant="outlined"
              sx={{ px: 1.5 }}
            />
          )}
          {xPais?.pais && (
            <Chip
              label={xPais.pais}
              size="small"
              color="primary"
              variant="outlined"
              sx={{ px: 1.5 }}
            />
          )}
        </Stack>
      )}

      {compare && (
        <>
          <Stack py={2}>
            <Divider />
          </Stack>
          <Stack direction="row" spacing={3} alignItems="center" justifyContent="flex-end">
            <Stack>
              <Button
                color="primary"
                variant="contained"
                sx={{ px: 4 }}
                endIcon={<Icon iconName="compare" size={21} />}>
                Comparar
              </Button>
            </Stack>
          </Stack>
        </>
      )}
    </Stack>
  );
});

IndicadorHeader.displayName = 'IndicadorHeader';

export default IndicadorHeader;
